import { getClient } from "./client-helper";
import { DownloadBookingDocumentsQueryResult, Document, BookingDocumentsQueryResult } from "./dtos";

export const downloadDocuments = async (documents: Document[]) => {
  const {gatewayApiUri, authToken} = await getClient();
  const bookingNumber = documents[0].bookingNumber;

  const response = await fetch(`${gatewayApiUri}/booking/${bookingNumber}/Documents/Downloads`, {
    headers: {
      "Authorization": `Bearer ${authToken}`,
      "Content-Type": "application/json"
    },
    method: 'Post',
    body: JSON.stringify({
      "documents": documents,
      "culture": "en-US"
    }),
  });

  if (!response.ok) {
    return Promise.reject(response.statusText);
  }

  const jsonResponse: DownloadBookingDocumentsQueryResult = await response.json();
  return jsonResponse;
}

export const getDocuments = async (bookingNumber: number, signal?: AbortSignal) => {
  const { gatewayApiUri, authToken } = await getClient();

  const response = await fetch(`${gatewayApiUri}/booking/${bookingNumber}/Documents`, {
    signal,
    headers: { Authorization: `Bearer ${authToken}` },
    method: 'Get',
  });

  if (!response.ok) {
    return Promise.reject(response.statusText);
  }

  const data: BookingDocumentsQueryResult = await response.json();
  return data.documents;
}

export const uploadDocument = async(bookingNumber: number, document: File, documentType: number, shipmentId: string) => {
  const {gatewayApiUri, authToken} = await getClient();

  const formData = new FormData();
  formData.append('documentContent', document);
  formData.append('documentType', documentType.toString());
  formData.append('shipmentId', shipmentId.toString());

  const response = await fetch(`${gatewayApiUri}/booking/${bookingNumber}/Documents`, {
    headers: {
      "Authorization": `Bearer ${authToken}`,
    },
    method: 'Post',
    body: formData,
  });

  if (!response.ok) {
    return Promise.reject(response.statusText);
  }

  return Promise.resolve();
}
